import { useAddToWishlist, useDeleteFromWishlist } from '@pkg/hooks';

import { type UseAddToWishlistParam } from '@app/client/common/structs/wishlists/wishlists';

import { useToastStore } from '../../Toast';

export function useUpdateWishlist() {
    const { addToast } = useToastStore();

    // TODO: We should surface "loading / pending" states,
    // as well as more details for why something failed,
    // such as "the token is already added to your wishlist".
    const { mutateAsync: handleAdd } = useAddToWishlist();
    const { mutateAsync: handleDelete } = useDeleteFromWishlist();

    function addToWishlist(params: UseAddToWishlistParam, onSuccess?: () => void, onError?: () => void) {
        const tokenName = params.name ?? 'Token';

        handleAdd(params).then((response) => {
            if (response.ok) {
                addToast({
                    emoji: '⭐',
                    message: `${tokenName} added to wishlist!`,
                });
                onSuccess?.();
            } else {
                onError?.();
            }
        });
    }

    function removeFromWishlist(params: UseAddToWishlistParam, onSuccess?: () => void, onError?: () => void) {
        const tokenName = params.name ?? 'Token';

        handleDelete(params).then((response) => {
            if (response.ok) {
                addToast({
                    emoji: '🔥',
                    message: `${tokenName} removed from wishlist!`,
                });
                onSuccess?.();
            } else {
                onError?.();
            }
        });
    }

    return {
        addToWishlist,
        removeFromWishlist,
    };
}
